import { render, staticRenderFns } from "./PhoneProjectView.vue?vue&type=template&id=161b0ccd&scoped=true"
import script from "./PhoneProjectView.vue?vue&type=script&lang=ts"
export * from "./PhoneProjectView.vue?vue&type=script&lang=ts"
import style0 from "./PhoneProjectView.vue?vue&type=style&index=0&id=161b0ccd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "161b0ccd",
  null
  
)

export default component.exports